import React, { useState, useCallback, useEffect, useRef } from "react";
import { Button, Icon } from "semantic-ui-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

import swal from "sweetalert";
import { isAuthAdmin } from "../../../../services/auth";

import {
  Container,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
  LinkRedirect,
  SemanticButton,
  Pagination,
  CreateButtonNoLink
} from "./styles";

import { producaov2 as api } from "../../../../services/apis";
import { systemLogs } from "../../../../services/system_logs";

const ListarEmpresas = (props) => {
  const [empresas, setEmpresas] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);

  const loadEmpresas = async (value = 1 ) => {
    try {
      const params = {
        page: value,
        search: search || "",
      };

      const res = await api.get("admin/empresas",{
        params
      });

      
      const { data: newEmpresas, pages: newPages, page: newPage } = res.data;
      
      console.log("newEmpresas",newEmpresas)
      setEmpresas(newEmpresas);
      setPages(newPages);
      setPage(newPage);

      systemLogs("empresas", "listou as empresas");
    } catch (err) {
      swal("Erro !", "Não foi possível carregar as empresas", "error");
    }
  };

  const deleteEmpresa = useCallback(
    (id) => {
      api.delete(`/admin/empresas/${id}`).then(async (res) => {
        const newEmpresas = [...empresas].filter(
          (empresa) => empresa.id !== id
        );

        setEmpresas(newEmpresas);
        swal(res.data.msg, "", "success");

        systemLogs("empresas", `deletou a empresa de id=${id}`);
      });
    },
    [empresas]
  );

  const handlePageChange = (e, value) => {
    setPage(value);
    loadEmpresas(value);
  };

  useEffect(() => {
    loadEmpresas();
  }, []);

  return (
    <div style={{width:"100%", paddingLeft:"250px"}}>
      <AdminMenu />
      <Container>
        <Title>Empresas</Title>

        <ContainerInputSearch className="ui fluid left icon input">
          <Input type="search" onChange={(e) => setSearch(e.target.value)} />
          <Icon name="search icon" />
          <CreateButtonNoLink onKeyPress={(e) => e.key === "Enter" || e.keyCode === 13 && loadEmpresas()}
 onClick={() => loadEmpresas()}>Buscar</CreateButtonNoLink>
          <CreateButton to="/admin/empresas/criar">Criar</CreateButton>
        </ContainerInputSearch>

        <Pagination
          page={page}
          onChange={handlePageChange}
          count={pages}
          shape="rounded"
        />

        <SemanticTable size="big" celled>
          <SemanticTable.Header>
            <SemanticTable.Row>
              <SemanticTable.HeaderCell>Id</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Foto</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Nome</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
            </SemanticTable.Row>
          </SemanticTable.Header>

          <SemanticTable.Body>
            {empresas
              .filter((empresa) =>
                empresa.nome.toLowerCase().includes(search.toLowerCase())
              )
              .map((empresa) => (
                <SemanticTable.Row>
                  <SemanticTable.Cell>{empresa.id}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    <img
                      src={empresa.logo}
                      alt="Imagem da empresa"
                      style={{ height: 30 }}
                    />
                  </SemanticTable.Cell>
                  <SemanticTable.Cell> {empresa.nome} </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    <>
                      <LinkRedirect
                        to={`/admin/empresas/detalhes/${empresa.id}`}
                      >
                        <SemanticButton icon="edit icon" info="edit" />
                      </LinkRedirect>

                      <SemanticButton
                        icon="trash icon"
                        info="delete"
                        onClick={(e) => deleteEmpresa(empresa.id)}
                      />
                    </>
                  </SemanticTable.Cell>
                </SemanticTable.Row>
              ))}
          </SemanticTable.Body>
        </SemanticTable>

        <Pagination
          page={page}
          onChange={handlePageChange}
          count={pages}
          shape="rounded"
        />
      </Container>
    </div>
  );
};

export default ListarEmpresas;
